import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/home.vue'
import ce from '@/components/ce.vue'
Vue.use(Router)

export default new Router({
  routes: [
    // {
    //   path: '/',
    //   name: 'Home',
    //   component: Home
    // },
    {
      path: '/',
      name: 'ce',
      component: ce
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js